export enum Layouts {
  GRID ='Grid',
  LARGE = 'Large',
  PRIVATE = 'Private',
}
